// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_ui/dependencies/SubjectNam... Remove this comment to see the full error message
import SubjectNameDependency from 'crm_ui/dependencies/SubjectNameDependency';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const truncateProp = {
  lineClamp: 2
};
const MiniCrmObjectHighlight = ({
  objectType,
  subjectId
}) => {
  const primaryDisplayLabel = SubjectNameDependency.deref({
    objectType,
    subjectId
  });
  if (!primaryDisplayLabel) return null;
  return /*#__PURE__*/_jsx(View, {
    overflow: "hidden",
    "data-test-id": "mini-crmobject-highlight",
    children: /*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-50",
      truncate: truncateProp,
      children: primaryDisplayLabel
    })
  });
};
export default MiniCrmObjectHighlight;